import { createActions } from 'redux-actions'

export const CMS_REQUEST_LOGIN_START = 'CMS_REQUEST_LOGIN_START'
export const CMS_REQUEST_LOGIN_SUCCESS = 'CMS_REQUEST_LOGIN_SUCCESS'
export const CMS_REQUEST_LOGIN_FAIL = 'CMS_REQUEST_LOGIN_FAIL'

export const CMS_REQUEST_LOGOUT_START = 'CMS_REQUEST_LOGOUT_START'
export const CMS_REQUEST_LOGOUT_SUCCESS = 'CMS_REQUEST_LOGOUT_SUCCESS'
export const CMS_REQUEST_LOGOUT_FAIL = 'CMS_REQUEST_LOGOUT_FAIL'

export const CMS_REQUEST_PING_START = 'CMS_REQUEST_PING_START'
export const CMS_REQUEST_PING_SUCCESS = 'CMS_REQUEST_PING_SUCCESS'
export const CMS_REQUEST_PING_FAIL = 'CMS_REQUEST_PING_FAIL'

export const {
    cmsRequestLoginStart,
    cmsRequestLoginSuccess,
    cmsRequestLoginFail,

    cmsRequestLogoutStart,
    cmsRequestLogoutSuccess,
    cmsRequestLogoutFail,

    cmsRequestPingStart,
    cmsRequestPingSuccess,
    cmsRequestPingFail,
} = createActions({

    [CMS_REQUEST_LOGIN_START]: (req) => ({ ...req }),
    [CMS_REQUEST_LOGIN_SUCCESS]: (res) => ({ res }),
    [CMS_REQUEST_LOGIN_FAIL]: (res) => ({ res }),

    [CMS_REQUEST_LOGOUT_START]: (req) => ({ ...req }),
    [CMS_REQUEST_LOGOUT_SUCCESS]: (res) => ({ res }),
    [CMS_REQUEST_LOGOUT_FAIL]: (res) => ({ res }),

    [CMS_REQUEST_PING_START]: (req) => ({ ...req }),
    [CMS_REQUEST_PING_SUCCESS]: (res) => ({ res }),
    [CMS_REQUEST_PING_FAIL]: (res) => ({ res }),
})